import { render, staticRenderFns } from "./Improvement.vue?vue&type=template&id=1077ffb0&scoped=true"
import script from "./Improvement.vue?vue&type=script&lang=js"
export * from "./Improvement.vue?vue&type=script&lang=js"
import style0 from "./Improvement.vue?vue&type=style&index=0&id=1077ffb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1077ffb0",
  null
  
)

export default component.exports